import { parseRatio } from './types';

/** 実効比率の照合の許容 (相対)。BE schema.RATIO_TOLERANCE と同じ */
const RATIO_TOLERANCE = 0.005;

type RatioSource = {
  aspect_ratio?: string | null;
  target_width?: number | null;
  target_height?: number | null;
};

/**
 * 生成時の実効比率 (backend/services/banner_layout/schema.py effective_aspect_ratio と同じ規則)。
 * 目標解像度 (target_width / target_height) があればその W:H、無ければ aspect_ratio。どちらも無い / 'none' なら null。
 */
export function effectiveAspectRatio(settings: RatioSource): string | null {
  const w = settings.target_width;
  const h = settings.target_height;
  if (typeof w === 'number' && typeof h === 'number' && Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
    return `${w}:${h}`;
  }
  const aspect = settings.aspect_ratio;
  if (typeof aspect === 'string' && aspect && aspect !== 'none' && aspect !== 'custom') return aspect;
  return null;
}

export function ratiosMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  const ra = parseRatio(a);
  const rb = parseRatio(b);
  if (ra === null || rb === null) return false;
  return Math.abs(ra - rb) <= RATIO_TOLERANCE * Math.max(ra, rb);
}
